import './App.css';
import React, { Component, Suspense, lazy } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
// import Home from './components/Home/Home';
import './components/styles.css';
import Loading from './components/Loading/Loading';

const Home = lazy(() => import('./components/Home/Home'));
const Story = lazy(() => import('./components/Story/Story'));
const WorkInProgress = lazy(() => import('./components/WorkInProgress/WorkInProgress'));
const KuariPass = lazy(() => import('./components/Articles/KuariPass/KuariPass'));
const Projects = lazy(() => import('./components/Projects/Projects'));
const Formula1 = lazy(() => import('./components/Formula1/Formula1'));
const Workout = lazy(() => import('./components/Workout/Workout'));
class App extends Component {

  updateView = (view) => {
    this.setState({ view });
  };


  render() {

    return (
      <div className="App">
        <Router>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/profile" element={<Projects />} />
              <Route exact path="/explorare" element={<Story />} />
              <Route exact path="/f1" element={<Formula1 />} />
              <Route exact path="/workouts" element={<Workout />} />
              <Route exact path="/story/2021/kuari-pass" element={<KuariPass />} />
              <Route path="/*" element={<WorkInProgress />} />
            </Routes>
          </Suspense>
        </Router >
      </div>);
  }
}

export default App;
